export const TEST_IDS = {
  nav: {
    home: "nav-home",
    about: "nav-about",
    certificates: "nav-certificates",
    services: "nav-services",
    contact: "nav-contact",
    appointment: "nav-appointment-cta",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    primaryCta: "hero-cta-primary",
    secondaryCta: "hero-cta-secondary",
    profileImage: "hero-profile-image",
    logo: (slug) => `hero-logo-${slug}`,
  },
  about: {
    timelineItem: (i) => `about-timeline-item-${i}`,
  },
  certificates: {
    viewBtn: (i) => `certificate-view-btn-${i}`,
    lightboxClose: "certificate-lightbox-close",
  },
  services: {
    card: (i) => `service-card-${i}`,
    waCta: (i) => `service-wa-cta-${i}`,
  },
  contact: {
    waBigBtn: "contact-wa-big-btn",
    form: "contact-form",
    submitBtn: "contact-submit-btn",
    nameInput: "contact-name-input",
    emailInput: "contact-email-input",
    phoneInput: "contact-phone-input",
    messageInput: "contact-message-input",
    phoneLink: "contact-phone-link",
    emailLink: "contact-email-link",
    instagramLink: "contact-instagram-link",
  },
  footer: {
    instagram: "footer-instagram",
    navLink: (slug) => `footer-nav-${slug}`,
  },
};
